var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useIntl } from "react-intl";
import { ErrorPage } from "peggirkit";
var Error = function (_a) {
    var links = _a.links;
    var intl = useIntl();
    return (_jsx(ErrorPage, { title: intl.formatMessage({ id: "somethingWentWrong" }), appName: "Serpotrack", errorText: intl.formatMessage({ id: "error" }), links: __spreadArray([
            {
                text: intl.formatMessage({ id: "homepage" }),
                href: "https://serpotrack.com/"
            }
        ], links, true) }));
};
export default Error;
